import { ca } from '@cian/analytics';

const getPopupType = isDecreasingBet => (isDecreasingBet ? 'decrease_bid' : 'cancel_bid');

export const trackConfirmPopupOpen = isDecreasingBet => {
  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Open_need_confirm_popup',
    label: getPopupType(isDecreasingBet),
  });
};

export const trackConfirmPopupResumeClick = isDecreasingBet => {
  ca('event', {
    name: 'oldevent',
    category: 'Auction_block',
    action: 'Confirm_need_confirm_popup',
    label: getPopupType(isDecreasingBet),
  });
};
